import { render, staticRenderFns } from "./saas_edit.vue?vue&type=template&id=4a1cf7f9&scoped=true"
import script from "./saas_edit.vue?vue&type=script&lang=js"
export * from "./saas_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1cf7f9",
  null
  
)

export default component.exports